import { FlexBox } from "components/Common/FlexBox"
import styled from "styled-components"

const Loader = styled.div`
  width: 40px;
  aspect-ratio: 1.154;
  --_g1: no-repeat radial-gradient(farthest-side, #fa4614 90%, #0000);
  --_g2: no-repeat radial-gradient(farthest-side, #ef4d96 90%, #0000);
  --_g3: no-repeat radial-gradient(farthest-side, #2cccd3 90%, #0000);

  background: var(--_g3) 50% 0, var(--_g2) 0 100%, var(--_g1) 100% 100%;
  background-size: 35% calc(35% * 1.154);
  animation: l16 1s infinite;

  @keyframes l16 {
    50%,
    100% {
      background-position: 100% 100%, 50% 0, 0 100%;
    }
  }
`

const LoadingText = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  color: #fff;
`

const FullPageLoading = ({ text = "" }: { text?: string }) => {
  return (
    <FlexBox
      $direction="column"
      $alignItems="center"
      $justify="center"
      style={{
        height: "100%",
        background: "linear-gradient(180deg, #00263A 53.39%, #141415 100%)",
      }}
      $gap={24}
    >
      <Loader />
      {text && <LoadingText>{text}</LoadingText>}
    </FlexBox>
  )
}

export default FullPageLoading
